import { collection, getDocs, addDoc, updateDoc, doc } from "firebase/firestore";
import { serviceResponse } from "./common";
import { db } from "./connect";

export interface Resource {
    id: string;
    name: string;
    positionName: string;
    fileName: string;
    uri: string;
    createAt: string;
    isActive: boolean;
}

const collectionName = "resources";

const getResources = async () => {
    try {
        const docRef = collection(db, collectionName);
        const docs = await getDocs(docRef);

        if (docs.empty) {
            return serviceResponse.notContent;
        }

        return docs.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
    } catch (error) {
        console.log(error);
        return serviceResponse.systemError;
    }
}

const createResource = async (name: string, positionName: string, fileName: string, uri: string) => {
    try {
        if (!name || !positionName || !fileName || !uri) {
            return serviceResponse.emptyFields;
        }

        const docRef = collection(db, collectionName);

        const resource: Resource = {
            fileName, positionName, uri,
            name: name.toLowerCase(),
            id: "",
            createAt: new Date().toJSON(),
            isActive: true
        }

        await addDoc(docRef, resource);
        return serviceResponse.ok;
    } catch (error) {
        console.log(error);
        return serviceResponse.systemError;
    }
}

const updateResource = async (resource: Resource) => {
    try {
        if (!resource.id) {
            return serviceResponse.emptyFields;
        }

        const docRef = doc(db, collectionName, resource.id);
        await updateDoc(docRef, { ...resource });
        return;
    } catch (error) {
        console.log(error);
        return serviceResponse.systemError;
    }
}

const toggleResourceStatus = async (id: string, isActive: boolean) => {
    try {
        if (!id) {
            return serviceResponse.emptyFields;
        }

        const docRef = doc(db, collectionName, id);
        await updateDoc(docRef, { isActive: !isActive });
        return serviceResponse.ok;
    } catch (error) {
        console.log(error);
        return serviceResponse.systemError;
    }
}

export { getResources, createResource, updateResource, toggleResourceStatus };